'use client';

import CutOffText from '@/components/CutOffText';
import Rate from '@/components/Rate';
import Image from 'next/image';
import Link from 'next/link';
import { useRef } from 'react';

function formatNumber(num) {
  if (num >= 10000) {
    const thousands = Math.floor(num / 1000);
    return `${thousands},000+`;
  } else {
    return `${num.toLocaleString()}+`;
  }
}

const CustomerReviews = ({ sortedAllReviewsItems, reviewsCount }) => {
  const containerRef = useRef(null);
  // 用 ref 存储拖拽状态，避免每次渲染重新创建
  const dragState = useRef({ isDragging: false, startX: 0, scrollLeft: 0, offsetLeft: 0 });

  const handleMouseDown = e => {
    const el = containerRef.current;
    if (!el) return;
    // 先读取几何属性（避免写后读导致强制重排）
    const offsetLeft = el.offsetLeft;
    const scrollLeftVal = el.scrollLeft;
    // 再写入样式
    el.style.cursor = 'grabbing';
    el.style.userSelect = 'none';
    dragState.current = { isDragging: true, startX: e.pageX - offsetLeft, scrollLeft: scrollLeftVal, offsetLeft };
  };

  const handleMouseLeave = () => {
    const el = containerRef.current;
    if (!el) return;
    dragState.current.isDragging = false;
    el.style.cursor = 'grab';
    el.style.userSelect = '';
  };

  const handleMouseUp = () => {
    const el = containerRef.current;
    if (!el) return;
    dragState.current.isDragging = false;
    el.style.cursor = 'grab';
    el.style.userSelect = '';
  };

  const handleMouseMove = e => {
    const { isDragging, startX, scrollLeft, offsetLeft } = dragState.current;
    if (!isDragging) return;
    e.preventDefault();
    // 复用 mousedown 时缓存的 offsetLeft，避免每帧强制重排
    const x = e.pageX - offsetLeft;
    const walk = (x - startX) * 2;
    containerRef.current.scrollLeft = scrollLeft - walk;
  };

  return (
    <div className='mt-[60px] px-[17px] lg_px-0'>
      <div className='mx-auto w-[1440px] max-w-full'>
        <div className='mb-[30px] flex items-end justify-between font-poppins text-[22px] font-[600] leading-[1.4] text-title lg_text-[30px]'>
          <h2 className='flex-1'>Trusted by {formatNumber(reviewsCount)} Customers</h2>
          <div className='flex shrink-0 items-center'>
            <div className='hidden items-center lg_flex'>
              <Rate
                disabled
                initialRating={5}
              />

              <Link
                href='/reviews'
                className=' ml-[20px] font-sans text-[16px] font-normal uppercase text-primary underline'
              >
                {(reviewsCount ?? 0).toLocaleString()} Reviews
              </Link>
            </div>

            <Link
              href='/bird-feeders?sort_by=best_sellers'
              className='font-sans text-[16px] font-normal uppercase text-primary underline lg_hidden'
            >
              Read more
            </Link>
          </div>
        </div>

        <div className='w-full'>
          <div
            id='scroll-container'
            ref={containerRef}
            onMouseDown={handleMouseDown}
            onMouseLeave={handleMouseLeave}
            onMouseUp={handleMouseUp}
            onMouseMove={handleMouseMove}
            className='flex overflow-x-auto whitespace-nowrap pb-[40px]'
          >
            {sortedAllReviewsItems &&
              sortedAllReviewsItems.map((item, index) => (
                <div
                  className='mr-[20px] w-[280px] shrink-0 select-none rounded-[20px] bg-[#F7F7F5] p-[20px] lg_mr-[26px] lg_w-[340px] lg_p-[30px]'
                  key={index}
                  draggable={false}
                >
                  <div className='flex w-full flex-col'>
                    <Link
                      href={`/${item.product.url_key}.html`}
                      className='block'
                    >
                      <Image
                        src={item.product.small_image.url}
                        alt=''
                        width={384}
                        height={384}
                        draggable={false}
                      />
                    </Link>
                    <div className='mt-[20px]'>
                      <Rate
                        disabled
                        initialRating={item.average_rating}
                      />
                    </div>

                    <p className=' mt-[15px] whitespace-normal text-left font-poppins font-[600] leading-[1.4] text-title'>
                      {item.summary}
                    </p>
                    <p className='mt-[5px] whitespace-normal font-poppins text-sm leading-[1.4] text-[#666]'>
                      <CutOffText
                        text={item.text}
                        length={240}
                      />
                    </p>

                    <p className='mt-[15px] font-poppins text-sm font-[600] leading-[1.2] text-title'>
                      {item.nickname}
                    </p>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerReviews;
